module.exports = __webpack_public_path__ + "img/6a5cbb7.jpg";